var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import columns from './columns';
export default __assign(__assign({}, columns), { origin: {
        label: 'Origem',
        field: 'origin',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, stock: {
        label: 'Estoque CD/Plataforma',
        field: 'stock',
        type: 'general',
        align: 'left',
        customWidth: 200,
        fixed: false,
        render: true,
        disableOrder: true,
    }, deposit: {
        label: 'Depósito-C010',
        field: 'deposit',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, storeDeposit: {
        label: 'Loja-C050',
        field: 'storeDeposit',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, balance: {
        label: 'Saldo-C060',
        field: 'balance',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, showcase: {
        label: 'Mostruário-C070',
        field: 'showcase',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, devolution: {
        label: 'Devolução-C080',
        field: 'devolution',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, totalStock: {
        label: 'Estoque total',
        field: 'totalStock',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, rupture: {
        label: 'Provável ruptura',
        field: 'rupture',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, lastEntryData: {
        label: 'Última entrada',
        field: 'lastEntryData',
        type: 'general',
        align: 'left',
        customWidth: 130,
        fixed: false,
        render: true,
        disableOrder: true,
    }, lastEntryQty: {
        label: 'Qtde. última entrada',
        field: 'lastEntryQty',
        type: 'general',
        align: 'left',
        customWidth: 150,
        fixed: false,
        render: true,
        disableOrder: true,
    }, qtyPending: {
        label: 'Qtde. pendente de entrega',
        field: 'qtyPending',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, beepedBy: {
        label: 'price.audit.beepedBy',
        field: 'beepedBy',
        type: 'general',
        align: 'left',
        customWidth: 350,
        fixed: false,
        render: true,
        disableOrder: true,
    } });
